export default __webpack_public_path__ + "static/media/toothpaste.33789f93.svg";